import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export const getSectionValidationSchema = (minTabs: number) => {
  return yup.object({
    title: yup.string().required('Le titre est obligatoire.'),
    position: yup
      .number()
      .typeError('La position doit être un nombre')
      .required('La position est obligatoire.'),
    content: yup
      .array()
      .of(yup.string().required('Chaque onglet doit contenir du contenu.'))
      .required('Le contenu est obligatoire')
      .min(minTabs, 'Tous les onglets doivent contenir des données valides.')
      .test(
        'non-empty-tabs',
        'Chaque onglet doit contenir du contenu.',
        (value) => {
          return value.every((val) => val && val.trim() !== '');
        },
      ),
  });
};

export type SectionFormValues = {
  title: string;
  position: number;
  content: string[];
};

export const useSectionForm = (minTabs: number) => {
  const { register, handleSubmit, errors, setValue, reset } =
    useFormHandler<SectionFormValues>(getSectionValidationSchema(minTabs));

  return { register, handleSubmit, errors, setValue, reset };
};
